var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center align-center fill-height"},[_c('v-icon',{staticClass:"mb-4",attrs:{"large":"","color":"rgba(0,0,0,0.75)"}},[_vm._v(" question_answer ")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-2 text-center"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v(" Send a message ")]),_c('div',[_vm._v(" to your customer. ")])])
}]

export { render, staticRenderFns }